// extracted by mini-css-extract-plugin
export default {"promotion":"styles_promotion__w31zk","heading":"styles_heading__h45LD","text":"styles_text__l1Eiv","expiry":"styles_expiry__JpfS6"};